/**
 * Dynamic dashboard widget configuration.
 *
 * Each entry defines which widgets to render for a given role + store_type combo.
 * Widgets are rendered in order. Missing combos fall back to DEFAULTS.
 *
 * Widget IDs correspond to components in components/dashboard/widgets/
 */

export const WIDGET_IDS = {
  REVENUE:       'RevenueWidget',
  PROFIT:        'ProfitWidget',
  SALES_TODAY:   'SalesTodayWidget',
  ORDERS:        'OrdersWidget',
  INVENTORY:     'InventoryWidget',
  LOW_STOCK:     'LowStockWidget',
  AI_INSIGHTS:   'AIInsightsWidget',
  FORECAST:      'ForecastWidget',
  POS_QUICK:     'POSQuickWidget',
  PAYMENTS:      'PaymentsWidget',
  EXPENSES:      'ExpensesWidget',
  BOOKINGS:      'BookingsWidget',
  DUE_RETURNS:   'DueReturnsWidget',
  ALERTS:        'AlertsWidget',
  CAMPAIGNS:     'CampaignsWidget',
};

/**
 * Role-based widget lists.
 * The Dashboard component renders exactly these widgets, in this order.
 */
export const DASHBOARD_CONFIG = {
  owner: {
    default: [
      WIDGET_IDS.REVENUE,
      WIDGET_IDS.PROFIT,
      WIDGET_IDS.SALES_TODAY,
      WIDGET_IDS.FORECAST,
      WIDGET_IDS.AI_INSIGHTS,
      WIDGET_IDS.LOW_STOCK,
      WIDGET_IDS.ORDERS,
    ],
    bridal_rental: [
      WIDGET_IDS.REVENUE,
      WIDGET_IDS.PROFIT,
      WIDGET_IDS.BOOKINGS,
      WIDGET_IDS.DUE_RETURNS,
      WIDGET_IDS.AI_INSIGHTS,
      WIDGET_IDS.FORECAST,
    ],
    supermarket: [
      WIDGET_IDS.REVENUE,
      WIDGET_IDS.PROFIT,
      WIDGET_IDS.SALES_TODAY,
      WIDGET_IDS.LOW_STOCK,
      WIDGET_IDS.INVENTORY,
      WIDGET_IDS.ORDERS,
      WIDGET_IDS.AI_INSIGHTS,
    ],
  },

  manager: {
    default: [
      WIDGET_IDS.SALES_TODAY,
      WIDGET_IDS.ORDERS,
      WIDGET_IDS.LOW_STOCK,
      WIDGET_IDS.ALERTS,
      WIDGET_IDS.CAMPAIGNS,
    ],
    bridal_rental: [
      WIDGET_IDS.BOOKINGS,
      WIDGET_IDS.DUE_RETURNS,
      WIDGET_IDS.ORDERS,
      WIDGET_IDS.ALERTS,
    ],
  },

  cashier: {
    default: [
      WIDGET_IDS.POS_QUICK,
      WIDGET_IDS.SALES_TODAY,
    ],
    bridal_rental: [
      WIDGET_IDS.POS_QUICK,
      WIDGET_IDS.BOOKINGS,
    ],
  },

  stock_clerk: {
    default: [
      WIDGET_IDS.INVENTORY,
      WIDGET_IDS.LOW_STOCK,
      WIDGET_IDS.ORDERS,
    ],
  },

  accountant: {
    default: [
      WIDGET_IDS.REVENUE,
      WIDGET_IDS.PROFIT,
      WIDGET_IDS.PAYMENTS,
      WIDGET_IDS.EXPENSES,
    ],
  },
};

/**
 * Resolve the widget list for a given role + store_type.
 * Falls back: store_type-specific → role default → hardcoded fallback.
 */
export function getWidgetsForRole(role, storeType) {
  const roleConfig = DASHBOARD_CONFIG[role] || DASHBOARD_CONFIG.cashier;
  return roleConfig[storeType] || roleConfig.default || [WIDGET_IDS.SALES_TODAY];
}
